

const cartReducer = (state, action) => {
    if (action.type === "REMOVE_ITEMS") {
        return {
            ...state,
            items: state.items.filter((element) => {
                return element._id !== action.payload;
            }),
        };
    }
    return state;

};

export default cartReducer;